import { LEGACY_FIELD_WL } from '../formValidator/constants';
import calculatedFieldsConfig from '../calculatedFieldsConfig';
import { INMATE_PROFILE_FIELDS, MEMBER_PROFILE_FIELDS } from '../../constants/calculated';
import { JMS_INMATE_VALUE, MEMBER_VALUE } from '../../constants/fieldAutocomplete';

const findConfigField = (keyFromSource, source) => {
  if (source === JMS_INMATE_VALUE) {
    const field = INMATE_PROFILE_FIELDS.find(f => f.value === keyFromSource);
    if (field) return { key: field.value, type: field.type };
  }
  if (source === MEMBER_VALUE) {
    const field = MEMBER_PROFILE_FIELDS.find(f => f.value === keyFromSource);
    if (field) return { key: field.value, type: field.type };
  }
  const calculatedFieldConfig = calculatedFieldsConfig.calculatedFieldConfig;
  const config = calculatedFieldConfig.find(c => c.value === keyFromSource);
  if (config === undefined) {
    const legacyData =
      LEGACY_FIELD_WL.find(field => field.key === keyFromSource) || {};
    return { key: legacyData.key, type: legacyData.type };
  }
  return { key: config.value, type: config.type };
};

export default findConfigField;
